var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPergola(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.98 26.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.85px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pergola_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.43,
    y1: 5.94,
    x2: 0.43,
    y2: 26.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.98,
    y1: 5.94,
    y2: 5.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.55,
    y1: 5.86,
    x2: 24.55,
    y2: 26.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.47,
    y1: 5.94,
    x2: 0.43,
    y2: 9.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.31,
    y1: 5.94,
    x2: 24.55,
    y2: 9.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.98,
    y1: 4.09,
    y2: 4.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.79,
    y1: 2.24,
    y2: 2.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.98,
    y1: 4.09,
    y2: 4.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.98,
    y1: 2.24,
    y2: 2.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.98,
    y1: 0.43,
    y2: 0.43
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPergola);
export default __webpack_public_path__ + "static/media/pergola.9bd2cddd72a54293baf6fbbaa8582690.svg";
export { ForwardRef as ReactComponent };